export default __webpack_public_path__ + "static/media/logo.78b8a09d.svg";